module.exports = __webpack_public_path__ + "static/media/priser-digi.768bb8a9.pdf";